import { configInputConverter } from '@seu-converter';
import {
  SeuApiConverter,
  SeuComponent,
  SeuComponentApi,
  SeuComponentBase,
  SeuToApiConverter,
} from '@seu-types';
import { SeuApiSaveComponent } from '../api';
import { handlesConverter } from './handle.converter';

export const componentConverter: SeuApiConverter<
  SeuComponent,
  SeuComponentApi
> = {
  fromApi: (input) => {
    return {
      ...input,
      id: String(input.id),
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.fromApi(configInput);
      }),
      outputHandles: handlesConverter.fromApi(input.outputHandles ?? []),
      inputHandles: handlesConverter.fromApi(input.inputHandles ?? []),
    };
  },
  toApi: (input) => {
    return {
      ...input,
      id: Number(input.id),
      capex: input.capex ?? undefined,
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.toApi(configInput);
      }),
      outputHandles: handlesConverter.toApi(input.outputHandles ?? []),
      inputHandles: handlesConverter.toApi(input.inputHandles ?? []),
      isDirectionSwapped: input.isDirectionSwapped ?? false,
    };
  },
};

export const saveComponentConverter: SeuToApiConverter<
  SeuComponentBase,
  SeuApiSaveComponent
> = {
  toApi: (input) => {
    return {
      ...input,
      capex: input.capex ?? undefined,
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.toApi(configInput);
      }),
      outputHandles: handlesConverter.toApi(input.outputHandles ?? []),
      inputHandles: handlesConverter.toApi(input.inputHandles ?? []),
    };
  },
};
